import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_tooltip = _resolveComponent("q-tooltip")
  const _component_q_item_section = _resolveComponent("q-item-section")
  const _component_q_icon = _resolveComponent("q-icon")
  const _component_MainMenuTieredMenu = _resolveComponent("MainMenuTieredMenu", true)
  const _component_q_menu = _resolveComponent("q-menu")
  const _component_q_item = _resolveComponent("q-item")
  const _component_q_list = _resolveComponent("q-list")

  return (_openBlock(), _createBlock(_component_q_list, {
    style: {"min-width":"100px"},
    onMouseenter: _ctx.emitOver,
    onMouseleave: _ctx.emitLeave
  }, {
    default: _withCtx(() => [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.items, (item, i) => {
        return (_openBlock(), _createBlock(_component_q_item, {
          key: i,
          clickable: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_q_item_section, {
              onClick: _withModifiers(($event: any) => (_ctx.itemClick($event, item)), ["stop"])
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t(item.label)) + " ", 1),
                _createVNode(_component_q_tooltip, {
                  anchor: "top middle",
                  delay: 1000
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(item.descr || item.label), 1)
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 2
            }, 1032, ["onClick"]),
            (item.items)
              ? (_openBlock(), _createBlock(_component_q_item_section, {
                  key: 0,
                  side: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_icon, { name: "keyboard_arrow_right" })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_q_menu, {
              modelValue: item.visibleChild,
              "onUpdate:modelValue": ($event: any) => (item.visibleChild = $event),
              anchor: "top right",
              self: "top left"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_MainMenuTieredMenu, {
                  items: item.items,
                  onLink: _ctx.itemClick
                }, null, 8, ["items", "onLink"])
              ]),
              _: 2
            }, 1032, ["modelValue", "onUpdate:modelValue"])
          ]),
          _: 2
        }, 1024))
      }), 128))
    ]),
    _: 1
  }, 8, ["onMouseenter", "onMouseleave"]))
}